import {createStore} from 'vuex';

import auth from '@/General/plugins/store/modules/auth';

export default createStore({
  namespaced: true,
  modules: {
    auth,
  },
});
